<template>
  <td :class="{ 'crud-field': true, 'saved': displaySaved }">
    <div v-if="!editing" @click="edit">
      <span v-if="!options.type || options.type === 'text' || options.type === 'number'">
        {{ textDisplay }} {{ value[field] !== undefined && value[field] !== null && value[field] !== '' ? options.unit : '' }}
      </span>
      <span v-if="options.type === 'bool'">
        <v-checkbox
          v-model="value[field]"
          :disabled="!editable || !options.editable"
          @change="boolChange"
          class="pa-0"
        ></v-checkbox>
      </span>
      <span v-if="options.type === 'color'">
        <div v-if="value[field]" :style="`background-color: ${value[field]}`" class="color-rect"></div>
      </span>
      <span v-if="options.type === 'interval'">
        {{ value[field] && formatInterval(value[field]) }}
      </span>
      <span v-if="options.type === 'date'">
        {{ value[field] && formatDate(value[field]) }}
      </span>
      <span v-if="options.type === 'enum'">
        {{ options.values[value[field]] || value[field] }}
      </span>
      <span v-if="options.type === 'reference'">
        {{ value[field] && value[field][options.display || 'name'] }}
      </span>
      <span v-if="options.type === 'references'" v-tooltip="{ content: formatReferencesTooltip(references) }">
         {{ formatReferences(references) }}
      </span>
      <span v-if="options.type === 'data'">
        <div v-for="(item, index) in dataChange" :key="index">{{ item }}</div>
      </span>
    </div>
    <div v-else>
      <form @submit.prevent="saveField" class="sm">
        <crud-input ref="field" :field="field" :options="options" v-model="value" @save="save" :focus="true" size="sm" />
      </form>
      <div class="field-actions elevation-1">
        <v-btn icon flat @click="cancel" size="sm" danger class="inaction ma-0 pa-0"><v-icon>clear</v-icon></v-btn>
        <v-btn icon flat @click="save" size="sm" success class="inaction ma-0 pa-0"><v-icon>check</v-icon></v-btn>
      </div>
    </div>
  </td>
</template>

<script>
import CrudInput from './CrudInput'
import DataChange from '@/models/DataChange'

export default {
  props: {
    field: String,
    options: Object,
    value: Object,
    editable: Boolean
  },
  data () {
    return {
      editing: false,
      preEdit: null,
      displaySaved: false
    }
  },
  computed: {
    references () {
      if (this.options.type !== 'references') return []
      if (!this.value[this.field]) return []
      if (!Array.isArray(this.value[this.field])) {
        console.warn('Field', this.field, 'is references, yet it doesn\'t contain array.', typeof this.value[this.field], this.value[this.field])
        return []
      }
      return this.value[this.field].map(item => item[this.options.displayField || 'name'])
    },
    dataChange () {
      if (this.options.type !== 'data') return []
      return DataChange.getDiff(this.value, this.field)
    },
    textDisplay () {
      let value = this.value[this.field]
      if (this.options.type === 'number' && typeof value === 'number') {
        value = value.toString()
      }

      if (!value) return ''

      if (this.options.displayLength) {
        return value.length > this.options.displayLength
          ? value.substr(0, this.options.displayLength - 3) + '...'
          : value
      }

      return value
    }
  },
  methods: {
    boolChange () {
      this.$emit('save', this.value, this.field)
    },
    saveField (e) {
      this.$refs.field.save()
    },
    save (e) {
      this.editing = false

      if (this.preEdit !== this.value[this.field]) {
        this.$emit('save', this.value, this.field)
      }

      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
    },
    cancel (e) {
      this.value[this.field] = this.preEdit
      this.editing = false

      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
    },
    edit () {
      // @TODO: Saving works, but highlights wrong entity and displays loading for entire screen
      if (!this.editable || !this.options.editable || this.options.type === 'bool') return

      this.preEdit = this.value[this.field]
      this.editing = true
      this.$emit('edited', this, this.value, this.field)
    },
    closeForm () {
      if (this.editing) {
        this.save()
      }
    },
    saved (item, field) {
      if (item._self !== this.value._self || field !== this.field) return

      this.displaySaved = true
      setTimeout(() => {
        this.displaySaved = false
      }, 1000)
    },
    formatDate (date) {
      return this.$format.date(date)
    },
    formatInterval (interval) {
      return this.$format.interval(interval)
    },
    formatReferences (data) {
      let display = this.formatReferencesTooltip(data)
      if (display.length > 50) {
        display = display.substr(0, 47) + '...'
      }
      return display
    },
    formatReferencesTooltip (data) {
      let display = data.join(', ')
      if (display.length > 50) {
        display = display.substr(0, 47) + '...'
      }
      return display
    }
  },
  components: {
    CrudInput
  }
}
</script>

<style>
.inaction {
  width: 32px;
  height: 27px;
}

.crud-field {
  transition: background-color 0.2s, color 0.2s;
}

.crud-field.saved {
  background-color: #5cb85c;
  color: #fff;
}

.color-rect {
  width: 32px;
  height: 16px;
  box-shadow: 0px 0px 5px #666;
}

.field-actions {
  position: absolute;
  margin-top: -20px;
  z-index: 2;
  background: #fff;
  border-radius: 0.25em;
}
</style>



// WEBPACK FOOTER //
// CrudField.vue?3ea42237